import React from 'react'
import { Card, Tag, Breadcrumb, Icon, Empty } from 'antd'
import moment from 'moment'
import * as _ from 'lodash'
import { RouteComponentProps } from 'react-router'

import { ComponentExt } from 'util/reactExt'
import VPlayer from 'components/VPlayer'

import styles from './index.scss'
interface IProps extends RouteComponentProps<any> {}
interface IState {}
const types: any = [
  {
    key: '1000101',
    value: 'video',
  },
  {
    key: '1000102',
    value: 'article',
  },
  {
    key: '1000103',
    value: 'audio',
  },
  {
    key: '1000106',
    value: 'video',
  },
]
class Detail extends ComponentExt<IProps, IState> {
  state = {
    breadCrumb: [
      { linkTo: '/housework', text: '经传家事' },
      { linkTo: '', text: '专题详情' },
    ],
    details: [],
    tags: [],
    checkedTags: [],
    recommendList: [],
  }

  async componentDidMount() {
    this.handleFetchData()
    onhashchange = () => this.handleFetchData()
  }

  componentWillUnmount() {
    onhashchange = null
  }

  handleFetchData = () => {
    const {
      location: { search },
    }: any = this.props
    const id = new URLSearchParams(search).get('id')
    // tslint:disable-next-line: variable-name
    const label_type = 1
    this.handleFetchHotArticleList({ label_type })
    this.handleFetchLabelList({ label_type })
    this.handleFetchArticleDetail({ article_id: Number(id) })
  }

  handleClickBreadCrumb = link => {
    if (link) {
      const { history }: any = this.props
      history.push('/housework')
    }
  }

  handleSliceString = (str, limit = 30) => {
    let res = str
    if (str && str.length > limit) {
      res = `${str.slice(0, limit)}···`
      return res
    }
    return res
  }

  async handleFetchArticleDetail(params: { article_id: number }) {
    try {
      const details = await this.api.family.getFamilyArticleDetial(params)
      this.setState({ details, checkedTags: details.data.labels })
      // console.log('details', details)
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchHotArticleList(params: {
    label_type: number
    type?: number
    limit?: number
  }) {
    try {
      const recommendList = await this.api.family.getFamilyHotArticleList(
        params,
      )
      this.setState({
        recommendList,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchLabelList(params: { label_type: number }) {
    try {
      const tags = await this.api.family.getFamilyLabelList(params)
      this.setState({ tags })
    } catch (err) {
      console.error(err.message)
    }
  }

  handleClickList = (e, data, type) => {
    // 阻止冒泡
    e.stopPropagation()
    const WINOPEN = url => {
      window.open(window.location.origin + url, '_blank')
    }
    if (type === 'li') {
      WINOPEN(`#/housework/detail/${type}?id=${data.id}`)
    } else if (type === 'tag') {
      WINOPEN(
        `#/housework/list/${type}?tagName=${data.label_name}&labelId=${data.id}`,
      )
    }
  }

  handleRenderVDContent = details => (
    <div key={details.id}>
      <Card>
        <div className={styles.title}>
          <h4>{details.title}</h4>
          <p>
            <span>
              {moment(details.publish_date * 1e3).format('YYYY-MM-DD HH:mm')}
            </span>
            {details.labels.length > 0 &&
              details.labels.map(item => (
                <span key={item.id}>{`#${item.label_name}`}</span>
              ))}
          </p>
        </div>
        <div className={styles.content}>
          <VPlayer
            type={types.filter(v => v.key === details.type)[0].value}
            src={details.content}
            onplay={() => console.log('---play')}
          />
        </div>
      </Card>
      <Card title="视频简介">{details.article_desc}</Card>
    </div>
  )

  handleRenderArticleContent = details => (
    <div key={details.id}>
      <Card>
        <div className={styles.title}>
          <h4>{details.title}</h4>
          <p>
            <span>
              {moment(details.publish_date * 1e3).format('YYYY-MM-DD HH:mm')}
            </span>
            {details.labels.length > 0 &&
              details.labels.map(item => (
                <span key={item.id}>{`#${item.label_name}`}</span>
              ))}
          </p>
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: details.content }}
          className={styles.content}
        />
      </Card>
    </div>
  )

  handleRenderContent = () => {
    const {
      details: { data },
    }: any = this.state
    let render
    if (_.isEmpty(data)) {
      return (
        <Card>
          <Empty description="暂无数据" />
        </Card>
      )
    }
    render = this.handleRenderArticleContent(data)
    if (data.type === '1000101') {
      render = this.handleRenderVDContent(data)
    }
    return render
  }

  handleRenderTag = () => {
    const { tags, checkedTags } = this.state
    if (_.isEmpty(tags) || _.isEmpty(checkedTags)) {
      return
    }

    return tags.map((itm, idx) => (
      <Tag
        key={itm.id}
        color={_.findIndex(checkedTags, o => o.id === itm.id) > -1 && '#108ee9'}
        onClick={e => this.handleClickList(e, itm, 'tag')}
      >
        {itm.label_name}
      </Tag>
    ))
  }

  handleRenderRecommend = () => {
    const { recommendList } = this.state
    if (_.isEmpty(recommendList)) {
      return
    }
    return _.map(recommendList, (itm, idx) => {
      if (idx === 0) {
        return (
          <li key={itm.id} onClick={e => this.handleClickList(e, itm, 'li')}>
            <img src={itm.img_url} alt={itm.article_desc} />
            <p>
              {this.handleSliceString(itm.title)}
              {itm.type === '1000101' && <Icon type="play-square" />}
            </p>
          </li>
        )
      }
      return (
        <li key={itm.id} onClick={e => this.handleClickList(e, itm, 'li')}>
          <p>
            {this.handleSliceString(itm.title)}
            {itm.type === '1000101' && <Icon type="play-square" />}
          </p>
        </li>
      )
    })
  }

  render() {
    const { breadCrumb } = this.state
    const {
      handleRenderContent,
      handleRenderTag,
      handleRenderRecommend,
      handleClickBreadCrumb,
    } = this
    return (
      <div className={styles.detail}>
        <div>
          {breadCrumb && breadCrumb.length > 0 && (
            <Breadcrumb separator=">">
              {breadCrumb.map((itm, idx) => {
                return (
                  <Breadcrumb.Item
                    onClick={() => handleClickBreadCrumb(itm.linkTo)}
                    key={idx}
                  >
                    <a>{itm.text}</a>
                  </Breadcrumb.Item>
                )
              })}
            </Breadcrumb>
          )}
        </div>
        <div className={styles.container}>{handleRenderContent()}</div>
        <div className={styles.others}>
          <div className={styles.contentRtBox}>
            <Card title="全部标签">{handleRenderTag()}</Card>
            <Card className={styles.recommend} title="推荐">
              <ul>{handleRenderRecommend()}</ul>
            </Card>
          </div>
        </div>
      </div>
    )
  }
}

export default Detail
